import React from 'react';
import { BellIcon, CalendarIcon, AlertCircleIcon } from 'lucide-react';
export const AIReminders: React.FC = () => {
  return <div className="space-y-4" data-id="element-952">
      <div className="flex items-center justify-between mb-4" data-id="element-953">
        <h1 className="text-2xl font-bold text-secondary flex items-center" data-id="element-954">
          <BellIcon size={24} className="mr-2" data-id="element-955" />
          Pengingat & Perencanaan RKA
        </h1>
        <div className="flex space-x-2" data-id="element-956">
          <button className="bg-secondary text-white px-4 py-2 rounded-md hover:bg-opacity-90" data-id="element-957">
            Ekspor RKA
          </button>
          <button className="bg-primary text-secondary px-4 py-2 rounded-md hover:bg-opacity-90 font-medium" data-id="element-958">
            + Tambah Pengingat
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-959">
        <div className="p-3 border-b border-gray-200 bg-neutral-light flex items-center justify-between" data-id="element-960">
          <h2 className="font-bold text-secondary flex items-center" data-id="element-961">
            <CalendarIcon size={18} className="mr-2" data-id="element-962" />
            Timeline Pengingat RKA
          </h2>
          <span className="text-xs bg-accent-info text-white px-2 py-1 rounded" data-id="element-963">
            Powered by AI
          </span>
        </div>
        <div className="p-4" data-id="element-964">
          <div className="relative" data-id="element-965">
            {/* Timeline */}
            <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gray-200" data-id="element-966"></div>
            {/* Timeline items */}
            <div className="space-y-8" data-id="element-967">
              {/* M-24 */}
              <div className="relative pl-8" data-id="element-968">
                <div className="absolute left-0 w-4 h-4 bg-primary rounded-full border-4 border-white" data-id="element-969"></div>
                <div className="bg-neutral-light p-4 rounded-lg" data-id="element-970">
                  <div className="flex items-center justify-between mb-2" data-id="element-971">
                    <span className="font-bold text-secondary" data-id="element-972">
                      M-24 (24 bulan sebelum berakhir)
                    </span>
                    <span className="text-xs bg-gray-200 px-2 py-1 rounded" data-id="element-973">
                      Agustus 2023
                    </span>
                  </div>
                  <p className="text-sm text-gray-700 mb-3" data-id="element-974">
                    Mulai identifikasi kebutuhan untuk aset yang akan berakhir
                    pada 2025. Persiapkan evaluasi awal untuk aset-aset kritis.
                  </p>
                  <div className="bg-white p-3 rounded border border-gray-200 mb-3" data-id="element-975">
                    <h3 className="font-medium text-secondary text-sm mb-2" data-id="element-976">
                      Aset yang perlu diperhatikan:
                    </h3>
                    <ul className="text-sm space-y-2" data-id="element-977">
                      <li className="flex items-start" data-id="element-978">
                        <span className="bg-accent-red w-2 h-2 rounded-full mt-1.5 mr-2" data-id="element-979"></span>
                        <div data-id="element-980">
                          <p className="font-medium" data-id="element-981">
                            Server Database Utama (Pusat)
                          </p>
                          <p className="text-xs text-gray-600" data-id="element-982">
                            Berakhir: Agustus 2025 • Nilai: Rp 2.5M
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-983">
                        <span className="bg-accent-red w-2 h-2 rounded-full mt-1.5 mr-2" data-id="element-984"></span>
                        <div data-id="element-985">
                          <p className="font-medium" data-id="element-986">
                            Lisensi Oracle Enterprise (Nasional)
                          </p>
                          <p className="text-xs text-gray-600" data-id="element-987">
                            Berakhir: Juli 2025 • Nilai: Rp 3.7M
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="flex justify-end" data-id="element-988">
                    <button className="bg-secondary text-white px-3 py-1.5 rounded text-sm" data-id="element-989">
                      Siapkan RKA
                    </button>
                  </div>
                </div>
              </div>
              {/* M-18 */}
              <div className="relative pl-8" data-id="element-990">
                <div className="absolute left-0 w-4 h-4 bg-primary rounded-full border-4 border-white" data-id="element-991"></div>
                <div className="bg-neutral-light p-4 rounded-lg" data-id="element-992">
                  <div className="flex items-center justify-between mb-2" data-id="element-993">
                    <span className="font-bold text-secondary" data-id="element-994">
                      M-18 (18 bulan sebelum berakhir)
                    </span>
                    <span className="text-xs bg-gray-200 px-2 py-1 rounded" data-id="element-995">
                      Februari 2024
                    </span>
                  </div>
                  <p className="text-sm text-gray-700 mb-3" data-id="element-996">
                    Mulai persiapan TOR/KAK untuk aset-aset yang akan
                    dianggarkan dalam RKA tahun depan. Lakukan analisis
                    kebutuhan dan spesifikasi.
                  </p>
                  <div className="flex justify-end" data-id="element-997">
                    <button className="bg-secondary text-white px-3 py-1.5 rounded text-sm" data-id="element-998">
                      Lihat Daftar Aset
                    </button>
                  </div>
                </div>
              </div>
              {/* M-12 */}
              <div className="relative pl-8" data-id="element-999">
                <div className="absolute left-0 w-4 h-4 bg-accent-red rounded-full border-4 border-white" data-id="element-1000"></div>
                <div className="bg-neutral-light p-4 rounded-lg border-2 border-accent-red" data-id="element-1001">
                  <div className="flex items-center justify-between mb-2" data-id="element-1002">
                    <div className="flex items-center" data-id="element-1003">
                      <AlertCircleIcon size={16} className="text-accent-red mr-1" data-id="element-1004" />
                      <span className="font-bold text-secondary" data-id="element-1005">
                        M-12 (12 bulan sebelum berakhir)
                      </span>
                    </div>
                    <span className="text-xs bg-accent-red bg-opacity-10 text-accent-red px-2 py-1 rounded font-medium" data-id="element-1006">
                      Perlu Tindakan Segera
                    </span>
                  </div>
                  <p className="text-sm text-gray-700 mb-3" data-id="element-1007">
                    <strong className="text-accent-red" data-id="element-1008">PENTING:</strong>{' '}
                    Finalisasi RKA untuk aset-aset yang akan berakhir tahun
                    depan. Pastikan semua dokumen pendukung telah siap.
                  </p>
                  <div className="bg-white p-3 rounded border border-gray-200 mb-3" data-id="element-1009">
                    <h3 className="font-medium text-secondary text-sm mb-2" data-id="element-1010">
                      Aset kritis yang perlu dimasukkan RKA:
                    </h3>
                    <ul className="text-sm space-y-2" data-id="element-1011">
                      <li className="flex items-start" data-id="element-1012">
                        <span className="bg-accent-red w-2 h-2 rounded-full mt-1.5 mr-2" data-id="element-1013"></span>
                        <div data-id="element-1014">
                          <p className="font-medium" data-id="element-1015">
                            Perangkat Keamanan Jaringan STIN
                          </p>
                          <p className="text-xs text-gray-600" data-id="element-1016">
                            Berakhir: Agustus 2024 • Nilai: Rp 1.8M
                          </p>
                        </div>
                      </li>
                      <li className="flex items-start" data-id="element-1017">
                        <span className="bg-accent-red w-2 h-2 rounded-full mt-1.5 mr-2" data-id="element-1018"></span>
                        <div data-id="element-1019">
                          <p className="font-medium" data-id="element-1020">
                            Lisensi Antivirus (Seluruh Deputi)
                          </p>
                          <p className="text-xs text-gray-600" data-id="element-1021">
                            Berakhir: September 2024 • Nilai: Rp 950JT
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="flex justify-end space-x-2" data-id="element-1022">
                    <button className="border border-accent-red text-accent-red px-3 py-1.5 rounded text-sm" data-id="element-1023">
                      Tunda
                    </button>
                    <button className="bg-accent-red text-white px-3 py-1.5 rounded text-sm" data-id="element-1024">
                      Buat RKA Sekarang
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1025">
        <div className="p-3 border-b border-gray-200 bg-neutral-light" data-id="element-1026">
          <h2 className="font-bold text-secondary" data-id="element-1027">
            Saran AI untuk Perencanaan RKA
          </h2>
        </div>
        <div className="p-4" data-id="element-1028">
          <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg" data-id="element-1029">
            <h3 className="font-medium text-secondary mb-2" data-id="element-1030">
              Rekomendasi Prioritas RKA Tahun Anggaran 2024
            </h3>
            <p className="text-sm text-gray-700 mb-3" data-id="element-1031">
              Berdasarkan analisis terhadap aset yang akan berakhir dan
              kebutuhan operasional, berikut adalah rekomendasi prioritas untuk
              RKA TA 2024:
            </p>
            <ol className="list-decimal list-inside text-sm space-y-2 mb-3" data-id="element-1032">
              <li className="text-gray-700" data-id="element-1033">
                <span className="font-medium text-secondary" data-id="element-1034">
                  Prioritas Tinggi:
                </span>{' '}
                Pembaruan infrastruktur keamanan jaringan di Pusat dan STIN
                (estimasi Rp 5.2M)
              </li>
              <li className="text-gray-700" data-id="element-1035">
                <span className="font-medium text-secondary" data-id="element-1036">
                  Prioritas Tinggi:
                </span>{' '}
                Perpanjangan lisensi software kritikal (Rp 3.7M)
              </li>
              <li className="text-gray-700" data-id="element-1037">
                <span className="font-medium text-secondary" data-id="element-1038">
                  Prioritas Menengah:
                </span>{' '}
                Upgrade perangkat komunikasi BINDA (Rp 2.3M)
              </li>
              <li className="text-gray-700" data-id="element-1039">
                <span className="font-medium text-secondary" data-id="element-1040">
                  Prioritas Menengah:
                </span>{' '}
                Pemeliharaan kendaraan taktis (Rp 1.8M)
              </li>
            </ol>
            <div className="flex justify-end" data-id="element-1041">
              <button className="bg-accent-info text-white px-3 py-1.5 rounded text-sm" data-id="element-1042">
                Lihat Analisis Lengkap
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};